import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import { SocialMedia } from 'src/types/schema/graphql'
import { Icon } from '@chakra-ui/react'
import { XIcon } from 'src/components/icons/XIcon'

interface ISocials {
    socials: SocialMedia[]
}

export enum SocialMediaEnum {
    facebook = 'Facebook',
    x = 'X',
    youtube = 'Youtube',
    instagram = 'Instagram',
}

const socialMediaConfig = {
    instagram: {
        title: 'Instagram',
        key: 'instagram',
        link: 'https://www.instagram.com/',
    },
    facebook: {
        title: 'Facebook',
        key: 'facebook',
        link: 'https://www.facebook.com/',
    },
    twitter: {
        title: 'X',
        key: 'x',
        link: 'https://www.x.com/',
    },
    youtube: {
        title: 'Youtube',
        key: 'youtube',
        link: 'https://www.youtube.com/',
    },

    // TODO: Need icons for these socials

    // untappd: {
    //     title: 'Untappd',
    //     key: 'untappd',
    //     link: 'https://www.untappd.com/',
    // },
    // flickr: {
    //     title: 'Flickr',
    //     key: 'flickr',
    //     link: 'https://www.flickr.com/',
    // },
}

const Socials: React.FC<ISocials> = ({ socials }) => {
    const SocialButton = ({ social }: { social: SocialMedia }) => {
        const { platform, handle } = social
        return (
            <a
                href={socialMediaConfig[platform]?.link + handle}
                target='_blank'
                rel='noreferrer'
                aria-label={`View ${socialMediaConfig[platform]?.title} page`}
                className='flex h-10 w-10 items-center justify-center rounded-sm bg-gray-50 duration-300 hover:bg-gray-100'
            >
                {socialMediaConfig[platform]?.title !== 'X' ? (
                    <UI.Icon
                        slug={socialMediaConfig[platform]?.title}
                        customClasses='text-dark'
                        size='md'
                        theme='link'
                        aria-label={`View ${socialMediaConfig[platform]?.title} page`}
                    />
                ) : (
                    <Icon as={XIcon} />
                )}
            </a>
        )
    }

    const uniqueSocials = socials.reduce((firstInstance, social) => {
        if (!firstInstance.some((item) => item.platform === social.platform)) {
            firstInstance.push(social)
        }
        return firstInstance
    }, [])

    return (
        <div className='flex flex-row space-x-6'>
            {uniqueSocials.map(
                (social) =>
                    Object.keys(socialMediaConfig).includes(social.platform) && (
                        <SocialButton social={social} key={social.platform} />
                    )
            )}
        </div>
    )
}

export default Socials
